import BaseRepository from '@/repositories/base/BaseRepository'

class FreeRoomApplyOrderRepository extends BaseRepository {
	// 获取推广房型明细
	queryPromotionRoomTypeDetail(params: any) {
		return this.get<any>({
			url: '/ebk-dkb-api/free-room-apply-order/query-promotion-room-type-detail',
			data: params,
		})
	}

    // 酒店确认申请
	confirm(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/free-room-apply-order/confirm',
			data: params,
		})
	}

	// 获取酒店确认记录
	getHotelConfirmRecord(params: any) {
		return this.get<any>({
			url: '/ebk-dkb-api/free-room-apply-order/get-hotel-confirm-record',
			data: params,
		})
	}
}

export default FreeRoomApplyOrderRepository
